// src/vo/DangTai.js
import React from "react";

// ============================================================
// ⏳ ĐANG TẢI
// ------------------------------------------------------------
// Trước Đợt N1 có MƯỜI BA chỗ hiện "đang tải", theo BỐN kiểu khác nhau:
//
//     <div className="card">⏳ Đang tải…</div>          (3 chỗ, dấu … thật)
//     <div className="reminder-loading">⏳ Đang tải X...</div>  (5 chỗ)
//     <div>⏳ Đang tải...</div>                          (5 chỗ, KHÔNG có lớp
//                                                        CSS nào — chữ trần)
//
// Lộn xộn cả về hình lẫn về chữ: chỗ dùng "…" một ký tự, chỗ dùng ba dấu
// chấm; chỗ có thẻ, chỗ không.
//
// Nói rõ ĐANG TẢI CÁI GÌ thì tốt hơn "Đang tải..." trống không — người dùng
// biết cái gì chưa hiện chứ không tưởng app đứng máy:
//     <DangTai gi="việc nhà" />   →  ⏳ Đang tải việc nhà…
//     <DangTai />                 →  ⏳ Đang tải…
// ============================================================

export default function DangTai({ gi }) {
  return (
    <div className="dang-tai" role="status">
      ⏳ Đang tải{gi ? ` ${gi}` : ""}…
    </div>
  );
}
